/**
 * Display form of a reading's raw message: pretty-printed JSON for parsed
 * payloads, the text verbatim when the stored message was not JSON.
 */
export const formatPayload = (payload) => {
	if (typeof payload === 'string') return payload;
	return JSON.stringify(payload, null, 2) ?? '';
};
